import { Injectable } from '@angular/core';
import { smoothPath } from 'svg-smoother';

@Injectable({
  providedIn: 'root',
})
export class MotionPathService {
  constructor() {}

  drawPath(
    currentState: any,
    controlVar: any,
    elementId: any,
    rebase = false,
    scale = 1
  ) {
    let path = '';
    // get component x y real
    let rect: any = document.getElementById(elementId)?.getBoundingClientRect();

    let adjustmentX = 0;
    let adjustmentY = 0;
    // do a timeout to allow the element t appear?

    currentState[controlVar]?.points.forEach((line: any, index: number) => {
      // always start at the component's centre?

      let startChar = 'M';
      if (index > 0) {
        startChar = 'L ';
      }
      if (index == 0 && !rebase) {
        if (rect) {
          adjustmentX = +rect.x + +rect.width / 2 - line.x1 * scale;
          adjustmentY = +rect.y + +rect.height / 2 - line.y1 * scale;
        }
      }
      if (index == 0 && rebase) {
        // so start at the center of the component=
        adjustmentX = -line.x1 + currentState.width / 2;
        adjustmentY = -line.y1 + currentState.height / 2;
      }

      path +=
        startChar +
        '' +
        (+line.x1 * scale + +adjustmentX) +
        ' ' +
        (+line.y1 * scale + +adjustmentY) +
        ' ' +
        (+line.x2 * scale + +adjustmentX) +
        ' ' +
        (+line.y2 * scale + +adjustmentY) +
        ', ';
    });
    if (path) {
      path = smoothPath(path, {
        radius: currentState[controlVar]?.smoothing,
      });
    }

    return path;
  }

  getPoints(
    currentState: any,
    controlVar: any,
    elementId: any,
    rebase = false,
    scale = 1
  ) {
    let points: any = [];
    // get component x y real
    let rect: any = document.getElementById(elementId)?.getBoundingClientRect();

    let adjustmentX = 0;
    let adjustmentY = 0;
    if (rect) {
      currentState[controlVar]?.points.forEach((line: any, index: number) => {
        // always start at the component's centre?
        if (index == 0 && !rebase) {
          adjustmentX = +rect.x + +rect.width / 2 - line.x1 * scale;
          adjustmentY = +rect.y + +rect.height / 2 - line.y1 * scale;
        }
        if (index == 0 && rebase) {
          // so start at the center of the component=
          adjustmentX = -line.x1 + currentState.width / 2;
          adjustmentY = -line.y1 + currentState.height / 2;
        }

        let point2 = {
          x: +line.x2 * scale + +adjustmentX,
          y: +line.y2 * scale + +adjustmentY,
        };

        points.push(point2);
      });
    }
    return points;
  }

  circlePath(
    currentState: any,
    controlVar: any,
    elementId: any,
    rebase = false,
    scale = 1
  ) {
    // can we do this with just the vars as it's just for animating?

    let cx: number = 0;
    let cy: number = 0;
    let startX = 0;
    let startY = 0;
    let r: number = currentState.motionPath.radius;

     let deg = 0;
    switch (currentState.motionPath.pathPos) {
      case 'b':

        deg = 0;
        //cx = currentState.width / 2;
        //cy = currentState.height / 2 + currentState.motionPath.radius;

        //cx = currentState.motionPath.radius;
        cy = currentState.motionPath.radius;
        break;
      case 'r':
      default:
        //cx = currentState.width / 2 + currentState.motionPath.radius;
        //cy = currentState.height / 2;

        deg = -180;
        cx = -currentState.motionPath.radius;
        cy = currentState.motionPath.radius/2;
        startX = currentState.motionPath.radius + currentState.width/2;
        startY = currentState.height/2;
        break;
      case 't':
        deg = 0;
        //cx = currentState.width / 2;
        //cy = currentState.height / 2 - currentState.motionPath.radius;

        cx = -currentState.motionPath.radius/2;
        cy = -currentState.motionPath.radius;
        break;
      case 'l':

        deg = 0;
        //cx = currentState.width / 2 - currentState.motionPath.radius;
        //cy = currentState.height / 2;

        cx = currentState.motionPath.radius;
        cy = currentState.motionPath.radius/2;
        break;
    }

    if(!rebase){
      let rect: any = document.getElementById(elementId)?.getBoundingClientRect();

          let adjustmentX = +rect.x + +rect.width / 2 * scale;
          let adjustmentY = +rect.y + +rect.height / 2  * scale;
          startX = adjustmentX +r;
          startY = adjustmentY;
    }
   
    var theta = deg*Math.PI/180,
        dx = r*Math.cos(theta),
        dy = -r*Math.sin(theta);
        
    return "M "+startX+" "+startY+"m "+dx+","+dy+"a "+r+","+r+" 0 1,0 "+-2*dx+","+-2*dy+"a "+r+","+r+" 0 1,0 "+2*dx+","+2*dy;

    return (
      'M ' +
      0 +
      ' ' +
      0 +
      ' m ' +
      cx +
      ', ' + cy + ' a ' +
      r +
      ',' +
      r +
      ' 0 1,1 ' +
      r * 2 +
      ',0 a ' +
      r +
      ',' +
      r +
      ' 0 1,1 -' +
      r * 2 +
      ',0'
    );
  }
}
